import React from 'react';
import PropTypes from 'prop-types';

const NoDataToDisplay = ({ header, details }) => (
  <div className="general-info-page page-content-container">
    <div className="general-info-text">
      <span className="font-weight-bold">{header}</span><br/>
      {details ? details : null}
    </div>
  </div>
);

NoDataToDisplay.propTypes = {
  header: PropTypes.string.isRequired,
  details: PropTypes.string,
};

NoDataToDisplay.defaultProps = {
  details: '',
};

export default NoDataToDisplay;
